<template>
  <section class="desktop-header">
    <ul>
      <li class="desktop-header-logo">
        <img src="//res.cdn.changbaimg.com/-/bafb5d9b43c6580a/logo.png">
      </li>
      <li v-for="(item, index) in menus" :key="index" :class="{ 'desktop-header-active': active === item.name }">
        <a :href="item.url">{{ item.text }}</a>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  name: 'DesktopHeader',

  props: {
    active: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      menus: [
        { name: 'home', text: '首页', url: 'http://changba.com' },
        { name: 'mic', text: '唱吧麦克风', url: '/njwap/yingjian/pc-mic/index/main' },
        { name: 'net-show', text: '演出节目', url: '/njwap/client/net-show/index/main' },
        { name: 'member-center', text: '会员中心', url: 'http://changba.com/now/membercenter.php' },
        { name: 'recharge', text: '金币充值', url: 'http://changba.com/payment/recharge.php' },
        { name: 'accompaniment', text: '上传伴奏', url: 'http://changba.com/now/banzou/list.php' },
        { name: 'post-production-mall', text: '后期制作', url: '/njwap/chanpin/mall/index/download' },
        { name: 'upload-video', text: '导入作品', url: '/njwap/client/upload-video/index/main' },
        { name: 'music-market', text: '原创购买', url: '/njwap/chanpin/music-market/index/download' }
      ]
    }
  }
};
</script>

<style lang="scss" no-px2rem>
.desktop-header {
  background: linear-gradient(-45deg, #f22, #ff0040);

  ul {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    max-width: 980px;
    height: 80px;
    margin: 0 auto;
    padding: 0;
    list-style: none;

    li {
      &.desktop-header-active {
        &:before {
          position: absolute;
          top: 0;
          right: 0;
          left: 0;
          display: block;
          width: 100%;
          height: 3px;
          background-color: #fff;
          content: "";
        }
      }

      &.desktop-header-logo {
        margin-right: 100px;
        margin-left: 0;

        img {
          width: 61px;
          vertical-align: middle;
        }
      }

      position: relative;
      margin-left: 20px;

      a {
        display: block;
        color: #fff;
        font-size: 16px;
        line-height: 80px;
        text-decoration: none;
      }
    }
  }
}
</style>
